import { useState } from "react";
import { Grid3x3 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CATEGORY_STYLE, ELEMENTS } from "@/lib/elements";

export const PeriodicTableButton = () => {
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState(null);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="periodic-table-button" aria-label="Periyodik tablo"
        className="fixed bottom-4 right-4 z-40 h-14 w-14 rounded-full bg-slate-950/60 backdrop-blur-md border-2 border-[#FACC15] grid place-items-center shadow-[0_0_18px_rgba(250,204,21,0.45)] hover:scale-105 transition-transform">
        <Grid3x3 className="h-6 w-6 text-[#FACC15]" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[rgba(2,6,23,0.85)] border-[rgba(71,85,105,0.45)] max-w-5xl w-[96vw] p-4" data-testid="periodic-table-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Periyodik Tablo</DialogTitle></DialogHeader>
          <div className="h-12 flex items-center gap-3" data-testid="periodic-selected">
            {sel ? (<><span className="font-display text-3xl font-black text-[#FACC15]">{sel.symbol}</span><span className="text-lg font-semibold">{sel.name}</span><span className="eyebrow">Atom no: {sel.z}</span></>)
              : <span className="text-slate-400 text-sm">Bir elemente dokun.</span>}
          </div>
          <div className="overflow-x-auto">
            <div className="grid gap-[3px] min-w-[720px]" style={{ gridTemplateColumns: "repeat(18, minmax(0, 1fr))" }}>
              {ELEMENTS.map((e) => (
                <button key={e.z} onClick={() => setSel(e)} style={{ gridRow: e.row, gridColumn: e.col }}
                  className={`aspect-square rounded-[4px] border text-[11px] leading-none flex flex-col items-center justify-center ${CATEGORY_STYLE[e.category]} ${sel?.z === e.z ? "ring-2 ring-[#FACC15]" : ""} ${e.row >= 9 ? "mt-2" : ""}`}>
                  <span className="text-[8px] opacity-70">{e.z}</span>
                  <span className="font-bold text-[13px]">{e.symbol}</span>
                </button>
              ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
